import PropTypes from 'prop-types';
import { Flex, spacingMixin, Text } from '@zillow/constellation';
import styled from 'styled-components';
import PhoneNumber from '../../../../../../components/PhoneNumber';

export const NO_CONTACT_MSG = 'No contact info provided';

export function ContactInfo({ title, name, phone, email, className }) {
  const hasAnyContactInfo = name || phone || email;
  return (
    <Flex display="flex" flexDirection="column" className={className}>
      {title && <Text fontType="bodySmallHeading">{title}</Text>}
      {!hasAnyContactInfo && <Text>{NO_CONTACT_MSG}</Text>}
      {name && <Text>{name}</Text>}
      {phone && <PhoneNumber phone={phone} />}
      {email && <Text style={{ wordBreak: 'break-word' }}>{email}</Text>}
    </Flex>
  );
}

ContactInfo.propTypes = {
  title: PropTypes.string,
  name: PropTypes.string,
  phone: PropTypes.string,
  email: PropTypes.string,
  className: PropTypes.string,
};

export default styled(ContactInfo)`
  ${spacingMixin}
`;
